// Game entry point - imports main files plus game-specific files
// Ensure userData is always defined as an object
window.userData = window.userData || {};
// Ensure jQuery sendkeys plugin is available in the bundle
import './jquery-global.js';
import './jquery-sendkeys-shim.js';
import './safe-bootstrap.js';
// Import all utility modules explicitly to ensure they're available
import './collection-utils.js';
import './string-utils.js';
import './cookie-utils.js';
import './image-utils.js';
import './auth-utils.js';
import './background-utils.js';
import './template-utils.js';
import './main-entry.js';
import './request-utils.js';
// Ensure global data accessor is available before navigation code
import './data-accessor.js';
import './retry-utils.js';
import './nlp-utils.js';
import './navigation-manager.js';
import './eventsource-manager.js';
import './chat-mode-switcher.js';
import './media-upload.js';
import './game-api-client.js';
// Ensure audio helpers are loaded before game logic uses them
import './audio.js';
import './translation-mode.js';
import './voices-sidebar.js';
import './chat-image-to-video.js';
import './character-share.js';
import './game.js';
import './file-upload.js';
import './router.js';
import './signup.js';
import './emoji-modal-optimized.js';
// Vendor libs like Howler and Fuse are loaded via script tags
window.__netwrckGameBundleReady = true;
